import { motion } from "framer-motion";
import { EdMark } from "./EdLogo";
import { waLink, WA_MESSAGES } from "../lib/whatsapp";

const Nav = () => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    className="fixed inset-x-0 top-0 z-50"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
      <a href="/" className="flex items-center gap-3" aria-label="ED LABS">
        <EdMark className="h-6 w-auto" />
        <span className="font-display text-xs font-extrabold tracking-[0.42em] text-paper">
          LABS
        </span>
      </a>
      <a
        href={waLink(WA_MESSAGES.general)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="nav-whatsapp-cta"
        className="group flex items-center gap-2 rounded-full border border-brand-neon/30 bg-surface/70 px-4 py-2 text-xs font-semibold tracking-wide text-paper backdrop-blur-md transition-colors duration-300 hover:border-brand-neon/70 hover:bg-brand/20"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-mint animate-pulse" />
        Bora crescer?
      </a>
    </div>
  </motion.header>
);

export default Nav;
